import {Grid, useMediaQuery, useTheme} from '@mui/material';

import Education from './Education';
import {Header} from './Header';
import {ProfileSectionCard} from './ProfileSectionCard';
import {SalaryExpectations} from './SalaryExpectations';
import SideMenu from './SideMenu';
import WorkExperience from './WorkExperience';
import {LanguageProficiency} from '../../../../../domain/languages';
import {ApplicantSkill} from '../../../../../types/applicantSkill/ApplicantSkill';
import {TrackRecord} from '../../../../../types/shared-types';
import {ExperienceMetadata} from '../../types';
import * as Types from '../../types';

interface ApplicantProfileViewProps {
  onEdit?: (formType: Types.ProfileFormType, id?: string) => void;
  onImageChange?: (file: File | null) => void;
  data: {
    basicInfo: Types.ProfileBasic;
    education: Types.ProfileEducation[];
    settings: Types.ProfileSettings;
    workExperience: Types.ProfileWorkExperience[];
    dreamJobDescription: string | null;
    skills: ApplicantSkill[];
    professionalExperience: TrackRecord<ExperienceMetadata>[];
    leadershipExperience: boolean;
    minSalaryValue?: number | null;
    maxSalaryValue?: number | null;
    earliestStartDate?: string;
    languages: {
      id: string;
      proficiency: LanguageProficiency;
    }[];
  };
  refetchProfile: () => void;
}

const ApplicantProfileView = ({onEdit, data, onImageChange, refetchProfile}: ApplicantProfileViewProps) => {
  const {
    basicInfo,
    education,
    settings,
    workExperience,
    dreamJobDescription,
    skills,
    languages,
    professionalExperience,
    leadershipExperience,
    maxSalaryValue,
    minSalaryValue,
    earliestStartDate,
  } = data;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={8} sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        <ProfileSectionCard>
          <Header
            onImageChange={onImageChange}
            onEdit={onEdit}
            isMobile={isMobile}
            basicInfo={basicInfo}
            settings={settings}
            refetchProfile={refetchProfile}
          />
        </ProfileSectionCard>
        <ProfileSectionCard>
          <SalaryExpectations onEdit={onEdit} minSalaryValue={minSalaryValue} maxSalaryValue={maxSalaryValue} />
        </ProfileSectionCard>
        <ProfileSectionCard>
          <WorkExperience
            data={{
              workExperience,
            }}
            onEdit={onEdit}
          />
        </ProfileSectionCard>
        <ProfileSectionCard>
          <Education
            data={{
              education,
            }}
            onEdit={onEdit}
          />
        </ProfileSectionCard>
      </Grid>
      <Grid item xs={12} lg={4}>
        <SideMenu
          skills={skills}
          languages={languages}
          dreamJobDescription={dreamJobDescription}
          isMobile={isMobile}
          professionalExperience={professionalExperience}
          settings={settings}
          onEdit={onEdit}
          leadershipExperience={leadershipExperience}
          earliestStartDate={earliestStartDate}
        />
      </Grid>
    </Grid>
  );
};

export default ApplicantProfileView;
